import { authenticatedRestClient } from 'helpers/restclient';

export default class SelfServeCreditService {
	static instance = new SelfServeCreditService();

	_endpoints = {
		summary: '/api/self_serve_credit_summary',
		credits: '/api/self_serve_credits',
		apply: (transactionId) => `/api/transactions/${transactionId}/self_serve_credit/apply`,
		reverse: (transactionId) => `/api/transactions/${transactionId}/self_serve_credit/reverse`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	getSummary = () => this.restClient.get(this._endpoints.summary);

	getCredits = ({ page = 1, perPage = 25, sortBy, direction } = {}, cancelToken) => {
		return this.restClient.get(
			this._endpoints.credits,
			{
				page,
				per_page: perPage,
				...(sortBy && { sort_by: sortBy }),
				...(direction && { direction }),
			},
			{},
			cancelToken,
		);
	};

	applyCredit = ({ transactionId, amount }, cancelToken) =>
		this.restClient.post(this._endpoints.apply(transactionId), { amount }, {}, cancelToken);

	reverseCredit = ({ transactionId }, cancelToken) =>
		this.restClient.post(this._endpoints.reverse(transactionId), {}, {}, cancelToken);
}
